"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateBucketOutput = {
    type: "structure",
    required: [],
    members: {
        Location: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Location"
        }
    }
};
//# sourceMappingURL=CreateBucketOutput.js.map